import ahoy from 'ahoy.js';

// override defaults
ahoy.configure({
  visitsUrl: "/ahoyyy/visits",
  eventsUrl: "/ahoyyy/events"
})

ahoy.trackClicks('.dataTable th:not([data-dt-order="disable"])');
